import { Grid, Skeleton, Stack, TextField, Typography, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { Question } from "../types";
import * as apiClient from "../api";
import QuestionEditCard from "../components/QuestionEditCard";
import AddCard from "../components/AddCard";
import QuestionJsonDialog from "../components/QuestionJsonDialog";

const LoadingCard = styled(Skeleton)({
  height: "6rem",
});


const Questions = () => {
  const [loaded, setLoaded] = useState(false);
  const [questions, setQuestions] = useState<Question[]>([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const loadQuestions = async () => {
      const res = await apiClient.getQuestions();
      setQuestions(res.data.questions);
      setLoaded(true);
    };

    loadQuestions();
  }, []);

  const bySearch = ({ questionId, question, additionalInfo }: Question) => {
    const lowerSearch = search.toLowerCase();
    return search
      ? questionId?.toLowerCase().includes(lowerSearch) ||
      question?.toLowerCase().includes(lowerSearch) ||
      additionalInfo?.toLowerCase().includes(lowerSearch)
      : true;
  };

  const filterQuestions = questions.filter(bySearch);

  const updateQuestion = (updatedQuestion: Question) => {
    setQuestions((prevQuestions) => prevQuestions.map((q) => q.questionId === updatedQuestion.questionId ? updatedQuestion : q))
  }

  const addQuestion = (newQuestion: Question) => {
    setQuestions((prevQuestions) => [newQuestion, ...prevQuestions])
  }

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h4">Questions</Typography>
        <TextField
          id="question-search"
          label="Search"
          variant="outlined"
          type="search"
          autoComplete="off"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <AddQuestion handleAdd={addQuestion} />
      </Stack>
      <Grid container rowSpacing={2} columnSpacing={2}>
        {!loaded ? (
          <>
            <Grid item>
              <LoadingCard variant="rectangular" />
            </Grid>
            <Grid item>
              <LoadingCard variant="rectangular" />
            </Grid>
            <Grid item>
              <LoadingCard variant="rectangular" />
            </Grid>
          </>
        ) :
          filterQuestions.length === 0 ? (
            <Typography marginTop="4rem" width="100%" textAlign="center">
              No questions found
            </Typography>
          ) : (
            filterQuestions.map((question) =>
              <Grid key={question.questionId} item>
                <QuestionEditCard
                  key={question.questionId}
                  question={question}
                  handleUpdate={updateQuestion}
                />
              </Grid>
            )
          )
        }
      </Grid>
    </Stack >
  );
}

export default Questions;

const AddQuestion = ({ handleAdd }: { handleAdd: (question: Question) => void }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <AddCard onClick={handleOpen} />
      <QuestionJsonDialog
        handleClose={handleClose}
        open={open}
        variant="add"
        handleUpdate={handleAdd}
      />
    </>
  );
}